import Default from './Default';

const Themes = ({ countdown, title }: { countdown: string; title: string }) => (
  <Default countdown={countdown} title={title} />
);

export default Themes;
